module.exports = __webpack_public_path__ + "static/media/landing-example.5b4bf34e.png";